import { defineComponent as _defineComponent } from 'vue'


// props
interface IProps {
	warn?: boolean;
	error?: boolean;
	success?: boolean;
	info?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    warn: { type: Boolean },
    error: { type: Boolean },
    success: { type: Boolean },
    info: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})